// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tools-app-root2{overflow:scroll;position:absolute;top:0;left:0}.transition2{z-index:999;height:100%;width:100%;display:none}.transition2[open=true]{display:block}", ""]);
// Exports
module.exports = exports;
